var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 9.0085 0 20.1217C0 30.1645 7.314 38.4889 16.876 40V25.9369H11.796V20.1217H16.876V15.6889C16.876 10.6464 19.86 7.86156 24.43 7.86156C26.618 7.86156 28.906 8.25394 28.906 8.25394V13.2039H26.386C23.9 13.2039 23.126 14.7553 23.126 16.3469V20.1217H28.672L27.786 25.9369H23.126V40C32.686 38.4909 40 30.1625 40 20.1217C40 9.0085 31.046 0 20 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/FooterFacebook.26496a3d361c1ef522acf6897d3a81ba.svg";
export { ForwardRef as ReactComponent };